import { AlertCircle, Mail, MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export const RENEWAL_PHONE = "+972506573200";
export const RENEWAL_PHONE_DISPLAY = "+972 50-657-3200";
export const RENEWAL_WHATSAPP = "972506573200";
export const RENEWAL_EMAIL = "support@legalix.ai";

const WHATSAPP_MESSAGE = encodeURIComponent(
  "שלום, הגישה למנוי של המשרד חסומה ואשמח להפעיל אותו מחדש",
);

export const isOfficeSubscriptionBlocked = (
  status?: string | null,
): boolean => status === "expired" || status === "cancelled";

/** @deprecated Use isOfficeSubscriptionBlocked. Same predicate. */
export const isOfficeSubscriptionExpired = isOfficeSubscriptionBlocked;

export const RenewSubscriptionDialog = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md" dir="rtl">
      <DialogHeader className="text-right sm:text-right">
        <DialogTitle>גישה חסומה</DialogTitle>
        <DialogDescription>
          הגישה למנוי חסומה. ליצירת קשר כדי להפעיל מחדש:
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-2">
        <Button
          type="button"
          variant="outline"
          className="h-auto justify-start gap-3 py-3"
          onClick={() =>
            window.open(`https://wa.me/${RENEWAL_WHATSAPP}?text=${WHATSAPP_MESSAGE}`, "_blank")
          }
        >
          <MessageCircle className="h-5 w-5 text-green-600" />
          <span className="flex flex-col items-start">
            <span className="font-medium">וואטסאפ</span>
            <span className="text-xs text-muted-foreground" dir="ltr">
              {RENEWAL_PHONE_DISPLAY}
            </span>
          </span>
        </Button>
        <Button
          type="button"
          variant="outline"
          className="h-auto justify-start gap-3 py-3"
          onClick={() => {
            window.location.href = `tel:${RENEWAL_PHONE}`;
          }}
        >
          <Phone className="h-5 w-5 text-blue-600" />
          <span className="flex flex-col items-start">
            <span className="font-medium">טלפון</span>
            <span className="text-xs text-muted-foreground" dir="ltr">
              {RENEWAL_PHONE_DISPLAY}
            </span>
          </span>
        </Button>
        <Button
          type="button"
          variant="outline"
          className="h-auto justify-start gap-3 py-3"
          onClick={() => {
            window.location.href = `mailto:${RENEWAL_EMAIL}?subject=${encodeURIComponent("שחזור מנוי")}`;
          }}
        >
          <Mail className="h-5 w-5 text-amber-600" />
          <span className="flex flex-col items-start">
            <span className="font-medium">אימייל</span>
            <span className="text-xs text-muted-foreground" dir="ltr">
              {RENEWAL_EMAIL}
            </span>
          </span>
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export const ExpiredSubscriptionChip = ({
  onOpenContacts,
}: {
  onOpenContacts: () => void;
}) => (
  <div className="inline-flex items-center gap-2 rounded-full border border-destructive/30 bg-destructive/10 py-1 pe-1 ps-3">
    <AlertCircle className="h-4 w-4 shrink-0 text-destructive" />
    <span className="text-sm font-medium text-destructive">הגישה חסומה</span>
    <Button
      type="button"
      size="sm"
      className="h-7 rounded-full px-3 text-xs"
      onClick={onOpenContacts}
    >
      ליצירת קשר
    </Button>
  </div>
);
